import _ from "lodash";
//import { DataPipeline } from "aws-sdk";

/*
Add view specific props to activity used in player
*/
export function transformToActivityPlayer(activity) {

	let activityClone = _.cloneDeep(activity);

	recurseActivityPlayer(activity, 0, activityClone.children);
	return activityClone;
}

function recurseActivityPlayer(activity, parentIndex, arr) {
	for (let i = 0; i < arr.length; i++) {
		if (arr[i].type === "list") {
			//set defaults for props that are new
			if (!arr[i].hasOwnProperty("backgroundColor")) { arr[i].backgroundColor = "#444444"; }
			if (!arr[i].hasOwnProperty("borderColor")) { arr[i].borderColor = "#cccccc"; }
			if (!arr[i].hasOwnProperty("iconColor")) { arr[i].iconColor = "#ffffff"; }

			arr[i].expanded = false;


		} else if (arr[i].type === "section") {

			arr[i].expanded = false;

		}

		if (arr[i].hasOwnProperty("children")) {
			recurseActivityPlayer(activity, i, arr[i].children);
		}
	}
}

/*
Strip view specific player props
*/
export function transformFromActivityPlayer(activity) {
	let activityClone = _.cloneDeep(activity);
	recurseFromActivityPlayer(activityClone.children);
	return activityClone;
}

function recurseFromActivityPlayer(arr) {
	for (let i = 0; i < arr.length; i++) {

		if (arr[i].type === "list") {
			delete arr[i].expanded;
		} else if (arr[i].type === "section") {
			delete arr[i].expanded;
		}

		if (arr[i].hasOwnProperty("children")) {
			recurseFromActivityPlayer(arr[i].children);
		}
	}
}

/*
Convert sketch pad paths so they match the output of the mobile app
 */
export function transformSketchPadImagePathsFromPlayer(sketchPadImagePaths, sketchPadDimensions) {


	let paths = [];
	if (sketchPadImagePaths) {

		_.each(sketchPadImagePaths, (line) => {

			//double pen width to match mobile
			let path = { color: line.brushColor, width: line.brushRadius * 2};

			let pathItem = {
				path: path
			};

			let data = [];
			_.each(line.points, (point) => {
				data.push(point.x + "," + point.y);
			});

			path.data = data;

			//adjust width to match mobile
			path.size = {
				width: sketchPadDimensions.width - 20,
				height: sketchPadDimensions.height- 60
			};

			paths.push(pathItem);

		});
	}
	return paths;

}


export function transformSketchPadDataForPlayer(item) {

	let { sketchPadImagePaths, sketchPadDimensions } = item;

	let data = {};
	if (sketchPadImagePaths && sketchPadDimensions) {		
		
		data.lines = [];
		data.width = sketchPadDimensions.width;
		data.height = sketchPadDimensions.height;

		_.each(sketchPadImagePaths, (pathItem) => {

			let path = pathItem.path;
		
			//mobile player uses half the size pen width
			let line = {brushColor: path.color, brushRadius: path.width / 2};
			let points = [];
				
			_.each(path.data, (point) => {				
				let pointArray = point.split(",");
				let newPoint = { x: parseFloat(pointArray[0]), y: parseFloat(pointArray[1]) };
				points.push(newPoint);
			});

			line.points = points;

			data.lines.push(line);
		});	
	}

	return data;
}


